import axios from "../../axios/interceptor.js";
import Toast from "../../component/toastify/Index";

export const getUmsatzplanungLists = async (payload) => {
    try {
        const response = await axios.post('/customer/umsatzplanung/get', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const forderungenOptions = async (clientId) => {
    try {
        const response = clientId ? await axios.get(`/customer/forderungen/options?clientId=${clientId}`) : await axios.get('/customer/forderungen/options')
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const getByIdUmsatzplanung = async (id, clientId) => {
    try {
        const response = clientId ? await axios.get(`/customer/umsatzplanung/get/${id}?clientId=${clientId}`) : await axios.get(`/customer/umsatzplanung/get/${id}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}

export const deleteUmsatzplanung = async (id, clientId) => {
    try {
        const response = clientId ? await axios.put(`/customer/umsatzplanung/delete/${id}?clientId=${clientId}`) : await axios.put(`/customer/umsatzplanung/delete/${id}`)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const createUmsatzplanung = async (payload) => {
    try {
        const response = await axios.post('/customer/umsatzplanung/create', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}


export const updateUmsatzplanung = async (payload) => {
    try {
        const response = await axios.put('/customer/umsatzplanung/update', payload)
        if (response?.data?.isSuccess) {
            return response.data
        } else {
            Toast(response?.data?.message, "error");
        }
    } catch (error) {
        Toast(error?.response?.data?.message ? error?.response?.data?.message : error?.message, "error");
    }
}